import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { spaceApiKeyService } from '@/api/services/serverless/space-api-key';

export const Route = createFileRoute(
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/api-keys',
)({
  validateSearch: z.object({
    createApiKey: z.coerce.boolean().nullish(),
  }),
  beforeLoad: ({ params: { accountId, spaceId } }) => ({
    listSpaceApiKeysQuery: spaceApiKeyService.listSpaceApiKeysQuery({ accountId, spaceId }),
  }),
  // Fetching the keys runs the permissions interceptor, which throws an AccessControlError
  // (handled as a not-found) when the user lacks read permissions.
  loader: ({ context: { queryClient, listSpaceApiKeysQuery } }) => queryClient.ensureQueryData(listSpaceApiKeysQuery),
  component: lazyRouteComponent(() => import('./api-keys.component'), 'SpaceApiKeysComponent'),
});
